export default __webpack_public_path__ + "static/media/ico-dolar.bbb7fb15.svg";